import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Deadlines extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">

          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h5 className="par_header">DEADLINES</h5>
            <div className="par">
              {/* <h6>AUTHOR/SPEAKER DEADLINES (EXTENDED)</h6> <br />
              Since the proceedings will be published soon after the conference by
              IEEE CPS, we are quite FLEXIBLE with paper submission deadline. WE HAVE
              A REVOLVING DEADLINE: ie, papers will be refereed within about 72 hours
              from the date of submission using our fast-track evaluation system (FTE)
              where referees receive a small honorarium payment for their services.
              <br />
              Authors who have already received a decision on their papers are to follow the instructions and the deadlines that appeared in the notification that they have already received (or about to receive). <br /> <br />
              Authors who missed the paper submission deadline but still wish to submit their papers for evaluation/consideration, please see below: <br /> <br />
            <b>Revolving Date: </b>  Submission of Papers <a target="_blank" href="https://american-cse.org/drafts/">(https://american-cse.org/drafts/)</a> <br/>
            <b>Revolving Date: </b>  Notification of acceptance will be emailed in about 72 hours from the date of submission. <br/>
            <b>Revolving Date: </b> Deadlines for uploading the Final papers & Author Registrations will appear in the notification that will be sent to the authors. <a href="https://www.american-cse.org/csci2023/registration">(https://www.american-cse.org/csci2023/registration)</a><br /> */}

             {/* <b>Registration will be accepted till December 16, 2023:</b> <br/>
             Online registration: <a href="https://www.american-cse.org/csci2023/registration">https://www.american-cse.org/csci2023/registration </a>
              <br/> <br/> */}
            {/* <b>December 13-15, 2023: </b> The 2023 International Conference on Computational
                         Science and Computational Intelligence <br />
                         (CSCI'23: Luxor – an MGM property, Las Vegas, USA) <br/>
                         <a href="https://www.american-cse.org/csci2023/ ">(https://www.american-cse.org/csci2023/)</a><br /> */}
                         {/* Location: <a href="https://www.american-cse.org/csci2023/venue" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/csci2023/venue</a> */}

            {/* <hr />
            <h6 >ATTENDEES/PARTICIPANTS WITHOUT PAPERS:</h6> <br /> */}
            {/* Due to numerous requests, the paper submission deadline is extended as shown below. Authors who have submitted their papers in response to earlier announcements, will receive the decision/status report of their papers shortly (if they have not yet received the decision).
            <br /><br />
            Authors who have already received a decision on their papers are to follow the instructions and the deadlines that appeared in the notification that they have already received.
            <br /><br /> */}
            <div className="par">
            {/* Since the proceedings will be published soon after the conference by CPS, we have some flexibility with paper submission deadline. WE HAVE A REVOLVING DEADLINE: papers will be refereed using the fast-track evaluation system (FTE) – i.e., referees will be assigned to each paper immediately when a paper is submitted.
            <br /><br /> */}

            {/* Due to numerous requests, the paper submission deadline is extended as shown below.
            Authors who have submitted their papers in response to earlier announcement, will
            receive the decision/status report of their papers shortly (if they have not yet received
            the decision).
            <br />
            <br />
            Authors who have already received a decision on their papers are to follow the
            instructions and the deadlines that appeared in the notification that they have already
            received. */}

            {/* The Opening Date for Paper Submissions: <br />
            &emsp; <b>September 10, 2023</b> <br /> 
            &emsp; <a target="_blank" href="https://american-cse.org/drafts/">https://american-cse.org/drafts/</a> 
            <br/>
            
            <br />
            The closing date for paper submissions: <br />
            &emsp; <b>October 25, 2023</b>

            <br /><br />
            Notification of acceptance or rejection: <br />
            &emsp; <b>November 5, 2023 (+/- 2 days)</b>

            <br /><br /> */}
            Author/Speaker Registration:<br />
            &emsp; <b>November 30, 2023</b> <br />
            &emsp; <a href="https://american-cse.org/csci2023/registration" target="_blank" rel="noopener noreferrer">https://american-cse.org/csci2023/registration</a>

            <br /><br />
            Non-Author/Non-Speaker Attendees/Participants:<br />
            &emsp; <b>December 10, 2023</b>
            

            <br /><br />
            The 2023 International Conference on Computational Science and Computational Intelligence (CSCI'23): <br />
            &emsp; <b>December 13-15, 2023</b> <br />
            &emsp; <a href="https://www.american-cse.org/csci2023/" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/csci2023/</a> <br />
            &emsp; + all affiliated Research Tracks: <br />
            &emsp; <a href="https://www.american-cse.org/csci2023/topics" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/csci2023/topics</a> <br />
            

            
            
            {/* <br /><b>October 25, 2023:  </b>  The closing date for paper submissions:  <br />
            <br /><b>November 3, 2023:  </b>  Notification of acceptance (+/- 2 days) <br />
            <br /><b>November 14, 2023: </b>  Author Registrations <br /> <a target="_blank" href="https://american-cse.org/csci2023/registration">https://american-cse.org/csci2023/registration</a> <br/>
            <br /><b>November 30, 2023: </b>  Final ACCEPTED papers to be uploaded to the CPS portal for publication. <br/>
            <br /><b>December 13-15, 2023: </b> The 2023 International Conference on Computational
                         Science and Computational Intelligence (CSCI'23)<br />
                         <a href="https://www.american-cse.org/csci2023/">https://www.american-cse.org/csci2023/</a><br />
                         + all affiliated Research Tracks: <br />
                         <a href="https://www.american-cse.org/csci2023/topics">https://www.american-cse.org/csci2023/topics</a><br /> */}

            <br /><br />
            
            </div>
            </div>

            {/* <br/> */}

            {/* <h5 className="par_header">Important Dates for LATE BREAKING PAPERS, POSITION PAPERS, ABSTRACTS/POSTERS</h5> */}

            {/* <div className="par">
            Due to numerous requests for extending the Paper Submission Deadline,
            we have now extended the deadlines for the following category
            of papers: The deadlines that appear below, only apply to papers submitted
            after October 18, 2023 (ie, this is an opportunity for those
            authors who missed the original deadline):
            <br/><br/>
            <b>November 5, 2023: </b>  Submission of Papers <a target="_blank" href="https://american-cse.org/drafts/">(https://american-cse.org/drafts/)</a> <br/>
            <b>Revolving Date: </b>  Notification of acceptance will be emailed in about 72 hours from the date of submission. <br/>
            <b>November 30, 2023: </b> Final papers & Author Registrations <br/> */}

            {/* <b>December 13-15, 2023: </b> The 2023 International Conference on Computational
                        Science and Computational Intelligence
                        (CSCI'23: Las Vegas, USA) <br/>
                        <a href="https://www.american-cse.org/csci2023/ ">(https://www.american-cse.org/csci2023/)</a>
              */}

              {/* <br/>
              For more details about the LATE Breaking Papers, POSITION Papers, ABSTRACT/POSTER Papers 
              and the submission instructions, refer to: <br/>
              <a href="https://american-cse.org/drafts/" target="_blank">https://american-cse.org/drafts/</a>

              <br/> <br/>
              Since the proceedings will be published soon AFTER the conference
              by IEEE CPS, we are quite FLEXIBLE with paper submission deadline.
              WE HAVE A REVOLVING DEADLINE: ie, papers will be refereed within
              72 hours from the date of submission using our fast-track evaluation
              system (FTE) where referees receive a small honorarium payment for
              their services.

            </div> */}

            
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Deadlines;